import { GetPrivacyPolicyUseCase } from '@/core/domain/privacy-policy/usecases/getPrivacyPolicy.usecase';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { of, switchMap } from 'rxjs';

@Component({
    selector: 'fe-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PrivacyPolicyComponent implements OnInit {
    public breadcrumbs = [
        {
            label: 'fe_breadcrumb_view_customer_support',
            url: 'contact-us-and-faqs',
        },
        {
            label: 'fe_breadcrumb_view_questions',
            url: 'questions',
        },
        {
            label: 'fe_breadcrumb_view_privacy_policy',
            url: 'questions/privacy-policy',
        },
    ];

    public privacyPolicyContent = '';

    constructor(
        private readonly getPrivacyPolicyUseCase: GetPrivacyPolicyUseCase,
    ) {}

    public ngOnInit(): void {
        this.getPrivacyPolicyUseCase
            .execute()
            .pipe(
                switchMap((response) => {
                    this.privacyPolicyContent = response.data.privacyPolicy;
                    return of(response);
                }),
            )
            .subscribe();
    }
}
